import { Progress as AntdProgress } from 'antd';
import styled from 'styled-components';

export const Progress = styled(AntdProgress)``;
